<template>
  <a-modal
    :visible="isOpen"
    width="70%"
    @cancel="cancel"
    @ok="confirm"
    :confirmLoading="confirmLoading"
    :closable="false"
  >
    <template #title>
      <div class="m-title">
        <span>Delivery Unit</span>
        <a-button type="link" @click="isEditPoNumber = !isEditPoNumber">
          <template #icon><edit-outlined /></template>
          Edit PoNumber
        </a-button>
      </div>
    </template>
    <a-form :label-col="{ span: 8 }" :rules="rules" :model="form" ref="formRef">
      <a-row>
        <a-col :span="12">
          <a-form-item label="Delivery Unit">
            <a-input
              allowClear
              v-model:value="form.customerPoNo"
              disabled
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="GroupNo">
            <a-input allowClear v-model:value="form.groupNo" disabled></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="Model Name">
            <a-input
              allowClear
              v-model:value="form.modelName"
              disabled
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="Batch Upload Id">
            <a-input
              allowClear
              v-model:value="form.batchUploadId"
              disabled
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="Route ID">
            <a-select
              v-model:value="form.routeId"
              allowClear
              :disabled="isEditPoNumber"
            >
              <a-select-option
                v-for="item in routeItems"
                :key="item.routeId"
                :value="item.routeId"
              >
                {{ item.routeId }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="PoNumber" name="poNumber">
            <a-select
              v-model:value="form.editPoNumber"
              v-if="isEditPoNumber"
              allowClear
            >
              <a-select-option
                v-for="item in poNumberList"
                :key="item.id"
                :value="item.id"
              >
                {{ item.customerPoNo }}
              </a-select-option>
            </a-select>
            <a-input v-else disabled v-model:value="form.poNumber"></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="PlanPickupDate">
            <a-date-picker
              show-time
              style="width: 100%"
              valueFormat="YYYY-MM-DD HH:mm"
              v-model:value="form.planPickupDate"
              :disabled="isEditPoNumber"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="RSDS">
            <a-date-picker
              show-time
              style="width: 100%"
              valueFormat="YYYY-MM-DD HH:mm"
              v-model:value="form.rsdsReqPickupDate"
              :disabled="isEditPoNumber"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="DeliveryUnitRemark">
            <a-input
              allowClear
              v-model:value="form.deliveryUnitRemark"
              :disabled="isEditPoNumber"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="Dmd Type" name="dmdType">
            <a-input
              :disabled="isEditPoNumber"
              allowClear
              v-model:value="form.dmdType"
            ></a-input>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </a-modal>
</template>
<script setup>
  import { defineProps, ref, inject, watchEffect, defineEmits } from 'vue'
  import { EditOutlined } from '@ant-design/icons-vue'
  import dayjs from 'dayjs'
  import { deepClone } from '@/utils'
  import request from '@/utils/request'
  import { message } from 'ant-design-vue'
  const emits = defineEmits()
  const props = defineProps({
    isOpen: Boolean,
    detailItem: Object,
    poNumberList: Array,
  })
  const routeItems = inject('routeItems')
  const isEditPoNumber = ref(false)
  const form = ref({})

  watchEffect(() => {
    if (props.isOpen) {
      isEditPoNumber.value = false
      const { rsdsReqPickupDate, planPickupDate } = props.detailItem
      form.value = {
        ...props.detailItem,
        rsdsReqPickupDate: dayjs(rsdsReqPickupDate).format('YYYY-MM-DD HH:mm'),
        planPickupDate: dayjs(planPickupDate).format('YYYY-MM-DD HH:mm'),
      }
    }
  })
  const formRef = ref(null)
  const rules = {
    dmdType: [
      { required: true, message: 'Please input Dmd Type!', trigger: 'blur' },
    ],
    poNumber: [
      { required: true, message: 'Please select poNumber!', trigger: 'change' },
    ],
  }
  const cancel = () => {
    formRef.value.resetFields()
    emits('onModalClose')
  }
  const confirmLoading = ref(false)
  const confirm = () => {
    formRef.value
      .validate()
      .then(async () => {
        if (!isEditPoNumber.value) {
          const rawData = deepClone(form.value)
          debugger
          rawData.planPickupDate = dayjs(rawData.planPickupDate).valueOf()
          rawData.rsdsReqPickupDate = dayjs(rawData.rsdsReqPickupDate).valueOf()
          rawData.mdRouteId = rawData.routeId
          confirmLoading.value = true
          request({
            url: '/api/shipment/updateShipmentDelivery',
            method: 'post',
            data: rawData,
          })
            .then(() => {
              message.success('Success!!!').then(() => {
                emits('needRefresh')
              })
            })
            .finally(() => {
              confirmLoading.value = false
            })
        } else {
          if (!form.value.editPoNumber) {
            message.error('Please select poNumber!')
            return
          }
          confirmLoading.value = true

          request({
            url: '/api/shipment/swapDeliveryHeader',
            params: {
              oldId: form.value.id,
              newId: form.value.editPoNumber,
            },
          })
            .then(() => {
              message.success('Success!!!').then(() => {
                emits('needRefresh')
              })
            })
            .finally(() => {
              confirmLoading.value = false
            })
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }
</script>
<style lang="less" scoped>
  .modal {
    height: calc(100vh - 260px);
    overflow: auto;
  }
  .m-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
</style>
